import React, { useEffect, useState } from 'react';
import './TopBanner.css';
import { Carousel } from 'antd';

type NonEmptyArray<T> = [T, ...T[]];
interface TopBannerI {
    data: NonEmptyArray<{
        defaultbackground: string;
        backroundImageSource?: NonEmptyArray<{
            img: string;
            width: number;
        }>;
        cssfile?: string
        text?: string | React.ReactNode;
        alt?: string;
        action?: () => void
        warning?: boolean; // New warning prop
    }>;
}

const TopBanner = (props: TopBannerI) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.addEventListener('resize', () => { setWindowWidth(window.innerWidth) });

        // Clean up the event listener
        return () => {
            window.removeEventListener('resize', () => { setWindowWidth(window.innerWidth) });
        };
    }, []);

    return (
        <div className='top-carousel'>
            <Carousel
                autoplay
                autoplaySpeed={5000}
                slidesToShow={1}
                dots={false}
                arrows
                draggable
                infinite
            >
                {props?.data?.map((data, idx) => {
                    let backgroundImage = data.defaultbackground;

                    if (data?.backroundImageSource && !data.warning) {
                        backgroundImage = data?.backroundImageSource?.find(a => a.width < windowWidth)?.img ?? data?.defaultbackground;
                    }

                    // Conditional class name for warning background
                    const bannerClass = data?.cssfile ? data?.cssfile : data.warning ? 'top-banner warning' : 'top-banner';

                    return (
                        <div onClick={data?.action ? data?.action : () => { }} key={idx}>
                            <div
                                className={bannerClass}
                                style={!data.warning ? { backgroundImage: `url(${backgroundImage})`, minHeight: "65px", cursor: "pointer" } : {}}
                            >
                                {data?.text && data?.text}
                            </div>
                        </div>
                    );
                })}
            </Carousel>
        </div>
    );
};

export default TopBanner;
